import React, { useCallback } from 'react'
import { FocusableComponentLayout } from '@noriginmedia/norigin-spatial-navigation'
import { store } from '../../store'
import tts from '../../lib/TTS'
import FocusableLink from '../../components/FocusableLink/index.ts'
import { SettingsVideoProps } from './types'

const TITLE = 'Video'
const LABEL = 'Auto-play Next Video:'
const ON = 'On'
const OFF = 'Off'

const SettingsVideo = ({ upNextEnabled, handleFocus }: SettingsVideoProps) => {
  const toggleUpNext = useCallback(() => {
    const newValue = !upNextEnabled

    store.dispatch({
      type: 'SET_UPNEXT_ENABLED',
      payload: newValue,
    })

    setTimeout(() => {
      const ttsText = `${TITLE}. ${LABEL} changed to ${newValue ? ON : OFF}`

      tts.stopRead()
      tts.addTextToRead(ttsText)
    }, 100)
  }, [upNextEnabled])

  const handleLinkFocus = (layout: FocusableComponentLayout) => {
    const accountSignoutTTS = `${TITLE}. Focused on ${LABEL} ${
      upNextEnabled ? ON : OFF
    }.`

    tts.stopRead()
    tts.addTextToRead(accountSignoutTTS)

    handleFocus?.(layout)
  }

  return (
    <div className="settings-section-container">
      <h2>{TITLE}</h2>
      <FocusableLink
        label={LABEL}
        onEnterPress={toggleUpNext}
        onFocus={handleLinkFocus}
        disableTTS
      >
        <h3>
          {LABEL} {upNextEnabled ? ON : OFF}
        </h3>
      </FocusableLink>
    </div>
  )
}

export default SettingsVideo
